import Cookies from 'js-cookie'

$(document).on('click', '.dropdown .language-item', (e) => {
  const code = e.target.dataset['code']
  if (code) {
    $('.dropdown .dropdown-toggle.current-language-text').innerText = e.target.textContent
    let url = new URL(location.toString())
    url.searchParams.set("locale", code)
    Turbolinks.visit(url.href)
  }
})
